import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-23862_monitorgoals_guided_playbook'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
